import * as actions from '../actionTypes'

const initialState = {
  doneLoading: false,
  attendanceModified: true,
};

const loadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_DONE_LOADING:
      return {
        ...state,
        doneLoading: action.payload,
      };
    case actions.SET_ATTENDANCE_MODIFIED:
      return {
        ...state,
        attendanceModified: action.payload,
      };
    default:
      return state;
  }
};

export default loadingReducer;



